import { connect, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import type { Dispatch } from 'redux';

import loaderImage from 'assets/loader.gif';
import { Progress } from 'UIPackage/MainModule/components/Progress';

import styles from './Loader.module.scss';
import { IRootState } from '../interfaces/IRootState';
import { userNotificationUnreadGetCount } from '../../../UserNotificationPackage/MainModule/actions/UserNotificationAction';
import { RootActions } from '../types/RootActions';

interface ILoaderProps {
  position?: 'absolute' | 'static';
  loading?: boolean;
  loadingProgress?: number;
}

export const LoaderWithoutStore = ({ loading, loadingProgress, position }: ILoaderProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffect(() => {
    if (
      !(window.location.pathname === '/private/lk/user-notification' || window.location.pathname === '/private/auth')
    ) {
      dispatch(userNotificationUnreadGetCount());
    }
  }, [dispatch]);

  if (!loading) {
    return null;
  }

  return (
    <div className={styles.LoaderWrap} data-position={position}>
      <div className={styles.LoaderContainer}>
        <div className={styles.Loader} style={{ backgroundImage: `url(${loaderImage})` }} />
        {loadingProgress !== undefined && <Progress className={styles.Progress} percent={loadingProgress} />}
      </div>
    </div>
  );
};

const mapStateToProps = (state: IRootState) => ({
  loading: state.core.loading > 0,
  loadingProgress: state.core.loadingProgress,
});

export const Loader = connect(mapStateToProps)(LoaderWithoutStore);
